import { useMemo } from "react";
import { Check } from "lucide-react";

const SYN = { cuffietta: "cappellino", berretto: "cappellino", muffole: "guantini", muffoline: "guantini",
  calzine: "calzini", bavetta: "bavaglino", coperta: "copertina", fascia: "fascia ombelicale" };
const FALLBACK = {
  cotone: ["Tutina intera", "Body", "Cappellino", "Guantini", "Calzini", "Bavaglino", "Fascia ombelicale", "Copertina"],
  merino: ["Tutina in lana", "Tutina in cotone", "Cappellino in lana", "Cappellino in cotone", "Guantini", "Calzini", "Copertina in lana"],
};

const ROWS = [
  ["Stagione giusta", "Tutto l'anno: perfetto in primavera ed estate, a strati anche in autunno.", "Autunno e inverno, per i nati nei mesi freddi."],
  ["Sulla pelle", "Fresco, morbido e traspirante: 100% cotone turco certificato.", "Caldo e leggero fuori, con i capi in 100% cotone a contatto con la pelle."],
  ["Per chi è indicato", "Per tutti i neonati, anche con la pelle più delicata e per l'uscita dall'ospedale.", "Per chi vive in città fredde o deve uscire spesso con il bimbo in inverno."],
];

const key = (name, type) => {
  const n = name.toLowerCase();
  const first = n.split(" ")[0];
  const base = SYN[first] || (n.startsWith("fascia") ? "fascia ombelicale" : first);
  const fiber = type === "cotone" ? "" : / in lana/.test(n) ? " in lana" : / in cotone/.test(n) ? " in cotone" : "";
  return base + fiber;
};

const contents = (products, type) => {
  const parsed = products.filter((p) => (p.pieces || []).length >= 3);
  if (parsed.length < 2) return FALLBACK[type];
  const count = {};
  parsed.forEach((p) => new Set(p.pieces.map((n) => key(n, type))).forEach((k) => { count[k] = (count[k] || 0) + 1; }));
  const top = Object.entries(count).filter(([, c]) => c >= 2).sort((a, b) => b[1] - a[1]).slice(0, 9);
  return top.length >= 4 ? top.map(([k]) => k[0].toUpperCase() + k.slice(1)) : FALLBACK[type];
};

const Pieces = ({ items, testid }) => (
  <ul className="space-y-1" data-testid={testid}>
    {items.map((it) => (
      <li key={it} className="flex items-center gap-1.5"><Check size={13} className="shrink-0 text-[#4E7363]" />{it}</li>
    ))}
  </ul>
);

export default function BirthSetsCompare({ all, isMerino }) {
  const lists = useMemo(() => ({
    cotone: contents(all.filter((p) => !isMerino(p)), "cotone"),
    merino: contents(all.filter(isMerino), "merino"),
  }), [all, isMerino]);
  const cell = "p-3 sm:p-4 align-top text-[12.5px] sm:text-sm leading-snug text-[#5C534E]";

  return (
    <div className="mt-6 overflow-hidden rounded-2xl border border-[#EAE3DC]" data-testid="birth-sets-compare">
      <div className="px-4 pt-4 text-xs uppercase tracking-[0.2em] font-semibold text-[#4E7363]">Cotone o lana merino?</div>
      <table className="w-full table-fixed mt-2">
        <thead>
          <tr className="bg-[#F6F9F7] text-left">
            <th className="w-[26%] p-3 sm:p-4" />
            <th className="p-3 sm:p-4 font-serif text-base sm:text-lg font-normal text-[#2D2825]">Cotone turco</th>
            <th className="p-3 sm:p-4 font-serif text-base sm:text-lg font-normal text-[#2D2825]">Lana merino</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map(([label, c, m], i) => (
            <tr key={label} className="border-t border-[#EAE3DC]" data-testid={`compare-row-${i}`}>
              <th className="p-3 sm:p-4 align-top text-left text-[11px] sm:text-xs uppercase tracking-wider font-semibold text-[#8C7F78]">{label}</th>
              <td className={cell}>{c}</td>
              <td className={cell}>{m}</td>
            </tr>
          ))}
          <tr className="border-t border-[#EAE3DC]">
            <th className="p-3 sm:p-4 align-top text-left text-[11px] sm:text-xs uppercase tracking-wider font-semibold text-[#8C7F78]">Cosa c'è dentro</th>
            <td className={cell}><Pieces items={lists.cotone} testid="compare-pieces-cotone" /></td>
            <td className={cell}><Pieces items={lists.merino} testid="compare-pieces-merino" /></td>
          </tr>
        </tbody>
      </table>
      <p className="px-4 pb-4 pt-1 text-[11.5px] text-[#8C7F78]">I capi più ricorrenti nei nostri corredini: il contenuto esatto è indicato in ogni prodotto.</p>
    </div>
  );
}
